import(/* webpackMode: "eager", webpackExports: ["VerifyEmailClient"] */ "/vercel/path0/apps/web/src/app/verify-email/verify-email-client.tsx");
